(() => {
  const GATED_CLASS = 'product-form__submit--easify-gated';
  const LOADING_CLASS = 'product-form__submit--easify-loading';
  const SUBMIT_SELECTOR = 'button[data-easify-atc-gate="active"]';
  const OPTIONS_SELECTOR = '.easify.portal .po-options-root, .easify .po-options-root';
  const RELEASE_DELAY_MS = 5000;

  function showLoadingLabel(button) {
    const label = button.querySelector('span');
    if (!label || button.dataset.easifyAtcOrigLabel != null) return;
    button.dataset.easifyAtcOrigLabel = label.textContent;
    label.textContent =
      (window.variantStrings && window.variantStrings.easifyLoadingOptions) || 'Loading options…';
    button.classList.add(LOADING_CLASS);
  }

  function restoreLabel(button) {
    const label = button.querySelector('span');
    if (label && button.dataset.easifyAtcOrigLabel != null) {
      label.textContent = button.dataset.easifyAtcOrigLabel;
    }
    delete button.dataset.easifyAtcOrigLabel;
    button.classList.remove(LOADING_CLASS);
  }

  function enableButton(button) {
    restoreLabel(button);
    button.classList.remove(GATED_CLASS);
    button.removeAttribute('aria-disabled');
    button.removeAttribute('data-easify-atc-gate');
  }

  function gate(productInfo) {
    if (!productInfo) return;

    const button = productInfo.querySelector(SUBMIT_SELECTOR);
    if (!button) return;

    if (productInfo.dataset.easifyAtcObserved === 'true') return;
    productInfo.dataset.easifyAtcObserved = 'true';

    showLoadingLabel(button);

    let released = false;
    let timeoutId = null;
    let observer = null;

    function release() {
      if (released) return;
      released = true;
      if (timeoutId) clearTimeout(timeoutId);
      if (observer) observer.disconnect();
      enableButton(button);
    }

    // If Easify options are already present, release immediately.
    if (productInfo.querySelector(OPTIONS_SELECTOR)) {
      release();
      return;
    }

    // Release as soon as Easify injects its options, so the loader is removed
    // before the max waiting time when options load quickly.
    observer = new MutationObserver(() => {
      if (productInfo.querySelector(OPTIONS_SELECTOR)) release();
    });
    observer.observe(productInfo, { childList: true, subtree: true });

    // Fallback: never keep the button locked longer than the max waiting time.
    timeoutId = setTimeout(release, RELEASE_DELAY_MS);
  }

  function init() {
    document.querySelectorAll('product-info').forEach(gate);
  }

  window.EasifyAddToCartGate = { gate };

  if (document.readyState === 'loading') {
    document.addEventListener('DOMContentLoaded', init);
  } else {
    init();
  }
})();
